// extracted by mini-css-extract-plugin
module.exports = {"resubscribeQuestionTitle":"_0imD2","rate":"_3ci388","rateNum":"_3quaAa","active":"_1Nw1G0","rateNumTitle":"iKcAgm","text":"_12SiEU","button":"_3sAOCa"};